import Http from "../services/http";
import { snackbar } from "../app/actions";

import {
  PARTNERSHIP_RESORTS_LOAD_SUCCESS,
  PARTNERSHIP_CHANNELS_LOAD_SUCCESS,
  PARTNERSHIP_RESORTS_SELECT,
  PARTNERSHIP_PARTNERS_CHANGE,
  PARTNERSHIP_SELECTION_CHANGE
} from "../actions";

import { asyncIndicatorShow, asyncIndicatorHide } from "../app/actions";

export const resortsLoadSuccess = resorts => ({
  type: PARTNERSHIP_RESORTS_LOAD_SUCCESS,
  resorts
});

export const loadResorts = () => dispatch => {
  dispatch(asyncIndicatorShow());
  return Http.get(`/resorts`)
    .then(result => {
      dispatch(resortsLoadSuccess(result));
      dispatch(asyncIndicatorHide());
      return result;
    })
    .catch(err => {
      console.log(err);
      dispatch(asyncIndicatorHide());
    });
};

export const channelsLoadSuccess = channels => ({
  type: PARTNERSHIP_CHANNELS_LOAD_SUCCESS,
  channels
});

export const loadChannels = () => dispatch => {
  dispatch(asyncIndicatorShow());
  return Http.get(`/channels`)
    .then(result => {
      dispatch(channelsLoadSuccess(result));
      dispatch(asyncIndicatorHide());
      return result;
    })
    .catch(err => {
      console.log(err);
      dispatch(asyncIndicatorHide());
    });
};

export const selectResortSuccess = (resort, merchants) => ({
  type: PARTNERSHIP_RESORTS_SELECT,
  resort,
  merchants: merchants.list,
  selecteds: merchants.partnerships
});

export const changePartnersSuccess = partners => ({
  type: PARTNERSHIP_PARTNERS_CHANGE,
  partners
});

export const selectResort = resort => dispatch => {
  dispatch(asyncIndicatorShow());
  return Http.get(`/partnership/${resort}`)
    .then(merchants => {
      dispatch(selectResortSuccess(resort, merchants));
      dispatch(asyncIndicatorHide());
      return merchants;
    })
    .catch(err => {
      console.log(err);
      dispatch(asyncIndicatorHide());
    });
};

export const selectPartner = selection => ({
  type: PARTNERSHIP_SELECTION_CHANGE,
  selection
});

export const addPartner = (resort, partner, cb) => dispatch => {
  dispatch(asyncIndicatorShow());
  return Http.post(`/partnership/${resort}/add-partner`, { partner })
    .then(partners => {
      dispatch(changePartnersSuccess(partners));
      dispatch(selectPartner(undefined));
      dispatch(asyncIndicatorHide());
      cb();
      return partners;
    })
    .catch(err => {
      console.log(err);
      dispatch(asyncIndicatorHide());
    });
};

export const removePartner = (resort, partner) => dispatch => {
  dispatch(asyncIndicatorShow());
  return Http.post(`/partnership/${resort}/remove-partner`, { partner })
    .then(partners => {
      dispatch(changePartnersSuccess(partners));
      dispatch(asyncIndicatorHide());
      return partners;
    })
    .catch(err => {
      console.log(err);
      dispatch(asyncIndicatorHide());
    });
};

export const activatePartner = (resort, partner, active) => dispatch => {
  dispatch(asyncIndicatorShow());
  return Http.post(`/partnership/${resort}/activate-partner`, {
    partner,
    active: active ? 1 : 0
  })
    .then(partners => {
      const snackbarWord = active ? "activé" : "désactivé";
      dispatch(snackbar(`Le partenariat a bien été ${snackbarWord}`));
      dispatch(changePartnersSuccess(partners));
      dispatch(asyncIndicatorHide());
      return partners;
    })
    .catch(err => {
      console.log(err);
      dispatch(asyncIndicatorHide());
    });
};

export const updatePartnershipChannels = (
  resort,
  partnership,
  channels
) => dispatch => {
  dispatch(asyncIndicatorShow());
  return Http.post(`/partnership/${resort}/update-partnership-channels`, {
    partnership,
    channels
  })
    .then(partners => {
      dispatch(snackbar(`Les canaux de vente ont bien été mis à jour`));
      dispatch(changePartnersSuccess(partners));
      dispatch(asyncIndicatorHide());
      return partners;
    })
    .catch(err => {
      console.log(err);
      dispatch(asyncIndicatorHide());
    });
};



// WEBPACK FOOTER //
// ./src/partnership/actions.js